import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import EventDetail from '../events/EventDetail';
import { Link } from 'react-router-dom';
import { findBySearchString } from '../../../common/utils/jsonUtils';
import CustomLoader from '../../common/CustomLoader';

export class EventTab extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  state = { eventsBySearch: [], searchKey: '', showLoader: false };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.projectId !== this.props.projectId) {
      this.props.actions.loadEvents({ projectId: nextProps.projectId, version: nextProps.version });
    }
    return true;
  }

  componentDidMount() {
    const { projectId, actions, version } = this.props;
    if (projectId) {
      actions.loadEvents({ projectId, version });
    }
  }

  handleRefresh() {
    const { actions, projectId, version } = this.props;
    if (projectId) {
      this.setState({ showLoader: true });
      actions.loadEvents({ projectId, version }).then(() => this.setState({ showLoader: false }));
    }
  }

  filterEventsBySearch = (event) => {
    const { value } = event.target;
    const { events } = this.props.home;
    const eventsBySearch = findBySearchString('eventTitle', value, events);
    this.setState({ eventsBySearch, searchKey: value });
  };

  listOfEventsToShow = (events) => {
    const { projectId, version } = this.props;
    return events.map((event) => (
      <EventDetail key={event._id} version={version} event={event} projectId={projectId} />
    ));
  };

  render() {
    const { projectId, home, version, isReadOnly } = this.props;
    const { showLoader } = this.state;
    const { events = [] } = home;
    const totalEventCount = events.length;

    return (
      <Fragment>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color position-relative width100 border-bottom-theme">
          <div className="gjs-pn-buttons">
            <span title="Events" className="padding-left-20">
              Events&nbsp;
              <span
                style={{ fontSize: '12px', cursor: 'default' }}
                data-tip="Total"
                title={'Total: ' + totalEventCount}
              >
                <i className="webconnect webconnect-info-circle"></i>
              </span>
            </span>
            <span
              title="Reload Events"
              className="gjs-pn-btn"
              style={{ display: 'flex', flexGrow: '1', justifyContent: 'end' }}
            >
              &nbsp;
              <a
                className="btn btn-theme-cancel btn-xs"
                data-tip="Reload Events"
                data-place="bottom"
                data-effect="solid"
                onClick={() => {
                  this.handleRefresh();
                }}
              >
                <i className="wb webconnect-refresh"></i>
              </a>
            </span>
            <span
              title="Add Event"
              style={{
                opacity: isReadOnly ? 0.5 : 1,
                cursor: isReadOnly ? 'not-allowed' : 'pointer',
                pointerEvents: isReadOnly ? 'none' : 'auto',
              }}
            >
              <Link
                className="btn btn-theme-submit btn-xs"
                data-tip="Add Event"
                data-place="bottom"
                data-effect="solid"
                to={isReadOnly ? '#' : `/events/${version}/v/${projectId}/create`}
              >
                <i className="wb webconnect-plus"></i> Add Event
              </Link>
            </span>
          </div>
          <div className="gjs-devices-c"></div>
        </div>
        <div id="blocks" className="column blocks is-abs--t-l gjs-one-bg blocks-open">
          <div className="gjs-blocks-cs gjs-one-bg gjs-two-color">
            <div className="gjs-block-categories">
              <div className="gjs-pn-panel height35 width100 position-relative">
                <div className="form-outline" style={{ padding: '10px' }}>
                  <input
                    type="search"
                    className="custom-bootstrap-form-control custom-bootstrap-form-control-sm"
                    placeholder="&#xf55c; Eg: Login Event"
                    style={{ fontFamily: 'Arial, Webconnect' }}
                    onChange={this.filterEventsBySearch}
                  />
                </div>
                {this.state.searchKey.length > 0 ? (
                  this.listOfEventsToShow(this.state.eventsBySearch)
                ) : events.length > 0 ? (
                  showLoader ? (
                    <CustomLoader loading={showLoader} />
                  ) : (
                    this.listOfEventsToShow(events)
                  )
                ) : (
                  ''
                )}
              </div>
              <div className="gjs-blocks-no-cat">
                <div className="gjs-blocks-c"></div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventTab);
